import * as React from 'react'

import Spinner from '../../atoms/Spinner/Spinner'

import Logo, { LogoType } from '../../atoms/Logo/Logo'
import * as styles from './SpinnerWithLabel.css'

const SpinnerWithLabel: React.FunctionComponent = () => {
  return (
    <div>
      <div className={styles.spinner}>
        <Spinner />
      </div>
      <div>
        <p className={styles.text}>powered by</p>
        <div className={styles.logo}>
          <Logo type={LogoType.GRAY} />
        </div>
      </div>
    </div>
  )
}

export default SpinnerWithLabel
